import { FailureType } from "../../../../types/FailureType";
import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

export const showKernelDraftFailedSaveWarning = (
  state: FailureType,
  action: NotebookAction
) => {
  switch (action.type) {
    case NotebookActionKey.SET_SHOW_KERNEL_DRAFT_FAILED_SAVE_WARNING:
      return action.payload.failureType;
    default:
      return state ?? null;
  }
};
